// extracted by mini-css-extract-plugin
module.exports = {"headline":"PriceChangedHeadline_headline_3L5Zu"};